import { render, staticRenderFns } from "./PublicationEditDialog.vue?vue&type=template&id=88433a6c"
import script from "./PublicationEditDialog.vue?vue&type=script&lang=js"
export * from "./PublicationEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports